import styled from 'styled-components';
import { useTranslate } from 'react-t7e';
import { FC } from 'react';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import { AboutUsHeading } from 'src/modules/about-us/components/shared/AboutUsHeading';
import { media } from 'src/styles/designs';
import { AboutUsSection } from 'src/modules/about-us/components/shared/AboutUsSection';
import { AboutUsVideos } from 'src/modules/about-us/components/AboutUsNeauviachannel/AboutUsVideos';
import { AboutUs_Videos } from 'src/graphql/schema.graphql';

const Description = styled.p`
  color: ${({ theme }) => theme.palette.gray3};
  margin-top: 16px;
`;

const Container = styled(AboutUsSection)`
  margin-top: 22px;
  margin-bottom: 50px;

  ${media.w.greaterThanOrEqual.desktop} {
    margin-top: 72px;
    margin-bottom: 86px;
  }
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 670px;
  margin: 16px auto 0;
  & + & {
    margin-top: 32px;
  }
`;

interface AboutUsNeauviachannelProps {
  videos?: AboutUs_Videos[];
}

export const AboutUsNeauviachannel: FC<AboutUsNeauviachannelProps> = ({
  videos,
}) => {
  const { _ } = useTranslate();

  return (
    <Container>
      <InnerContainer>
        <AboutUsHeading>
          <Markdown>{_('NEAUVIABILITY')}</Markdown>
        </AboutUsHeading>
        <Description>
          <Markdown>
            {_(
              'Neauvia reason for being and commitment has 3 basic pillars: Science, Disruption and Lifestyle. Neauvia aims to provide a disruptive approach and solutions to the aesthetic market, always backed up by Science and Clinical Data, and by developing an iconic brand appealing to consumers.',
            )}
          </Markdown>
        </Description>
      </InnerContainer>
      <InnerContainer>
        <AboutUsHeading>
          <Markdown>{_('PEG-HA FILLERS')}</Markdown>
        </AboutUsHeading>
        <Description>
          <Markdown>
            {_(
              'Neauvia fillers are based on a unique SMART CROSSLINKING TECHNOLOGY – SXT – using PEG as a crosslinking agent, that provides unique properties and safety profile to NEAUVIA PEG-HA gels.',
            )}
          </Markdown>
        </Description>
      </InnerContainer>
      <InnerContainer>
        <AboutUsHeading>
          <Markdown>{_('ADVANCED HOLISTIC APPROACH')}</Markdown>
        </AboutUsHeading>
        <Description>
          <Markdown>
            {_(
              'Thanks to PEG-HA gels specific properties, and in line with a unique holistic vision of Aesthetics, NEAUVIA Research & Development investigated combined anti-aging therapies including Medical Devices, Energy Based Devices and Cosmeceuticals. Through synergistic protocols, NEAUVIA ADVANCED HOLISTIC APPROACH demonstrates today amplified rejuvenation outcomes for patients worldwide.',
            )}
          </Markdown>
        </Description>
      </InnerContainer>
      <AboutUsVideos videos={videos} />
    </Container>
  );
};
